export default __webpack_public_path__ + "static/media/everybyte-logo.af7c405f.png";